import { render, staticRenderFns } from "./ClipboardTypeIcon.vue?vue&type=template&id=02a98be8&scoped=true"
import script from "./ClipboardTypeIcon.vue?vue&type=script&lang=js"
export * from "./ClipboardTypeIcon.vue?vue&type=script&lang=js"
import style0 from "./ClipboardTypeIcon.vue?vue&type=style&index=0&id=02a98be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a98be8",
  null
  
)

export default component.exports